import { containsPeriodId, currentMonth, findMatchingPeriod } from '@shared/evaluation-period.helpers';

/** Guarda el resultado común de periodo y evaluación. */
export function storePeriodResult(state: any, res: any): void {
  state.period = res.period;
  state.evaluation = res.evaluation || [];
  state.loading = false;
  state.noPeriodForMonth = false;
  const found = findMatchingPeriod(state.periods, res.period);
  if (found) state.selectedPeriod = found;
  state.selectedMonth = currentMonth(state.period, state.selectedPeriod, state.selectedMonth);
}

/** Agrega el periodo al inicio si es nuevo. */
export function prependPeriod(state: any, period: any): void {
  if (!containsPeriodId(state.periods, period.id)) state.periods = [period, ...state.periods];
}

/** Aplica la selección del mes visible. */
export function applyMonthSelection(state: any, found: any, load: (date: string) => void): void {
  if (found) selectFoundMonth(state, found, load);
  else clearMonthSelection(state);
}

/** Selecciona el periodo encontrado para el mes. */
export function selectFoundMonth(state: any, found: any, load: (date: string) => void): void {
  state.selectedPeriod = found;
  state.noPeriodForMonth = false;
  load(found.period);
}

/** Limpia el estado cuando el mes no tiene periodo. */
export function clearMonthSelection(state: any): void {
  state.noPeriodForMonth = true;
  state.period = null;
  state.evaluation = [];
  state.selectedPeriod = null;
}
